import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useResource, Resources } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";
import { useNotificationQuery } from "Api/Queries/Notifications/useNotificationQuery";
import { NotificationForm } from "Components/Notifications/NotificationsManagement/NotificationForm/NotificationForm";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import type { ReactNode } from "react";

export const EditNotificationPage = () => {
  const { t } = useResource();
  const { id: publicID } = useParams<{ id: string }>();
  const {
    data: notificationData,
    isFetching,
    isError,
  } = useNotificationQuery(publicID);

  if (isFetching) {
    return (
      <Layout>
        <CenteredCircularProgress />
      </Layout>
    );
  }

  if (isError || !notificationData) {
    return (
      <Layout>
        <ErrorText>{t(Resources.Errors.RequestError)}</ErrorText>
      </Layout>
    );
  }

  return (
    <Layout>
      <NotificationForm mode="update" notificationData={notificationData} />
    </Layout>
  );
};

type LayoutProps = { children: ReactNode };

const Layout = ({ children }: LayoutProps) => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.EditNotification)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("notifications-management"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">{children}</div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
